import logging from "utils/logging";
import React from "react";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectGameId,
  selectGameStatusObject,
} from "../../gamestate/gameStateSlice";
import { selectQuestionById } from "features/question/questionSlice";
import { beginDailyDoubleAction, beginQuestionAction } from "../gameBoardSlice";

const log = logging.getLogger("GameBoard-Cell");

// Define brand colors
const ACCENT_TEAL = '#2ec4b6';
const ACCENT_YELLOW = '#ffe066';  

const StyledPaper = styled(Paper)(({ theme, isMoneyCell }) => ({
  height: "100%",
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textAlign: "center",
  padding: theme.spacing(0.3),
  margin: theme.spacing(0.2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: ACCENT_TEAL,
  fontFamily: "Helvetica Inserat, Arial, sans-serif",
  color: isMoneyCell ? "black" : "white",
  letterSpacing: "3px",
  boxShadow: `0 4px 16px rgba(44,62,80,0.18)` ,
  borderRadius: theme.spacing(1.5),
  cursor: isMoneyCell ? "pointer" : "default",
  position: "relative",

  boxSizing: "border-box",
}));

const CellText = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "2.5em",
});

const GameBoardCell = ({ label, status, questionId, 'data-cellid': dataCellId }) => {
  const dispatch = useDispatch();
  const gameId = useSelector(selectGameId);
  const gameState = useSelector(selectGameStatusObject);
  const questionObj = useSelector((state) =>
    selectQuestionById(state, questionId)
  );

  const available = !questionObj?.picked;

  const isMoneyCell = !!questionId;

  const onClick = () => {
    if (!questionId) {
      return;
    }

    if (!available) {
      return;
    }

    if (questionObj.dailyDouble) {
      log.debug("Picking the daily double");
      dispatch(beginDailyDoubleAction(gameId, gameState, questionId));
    } else {
      dispatch(beginQuestionAction(gameId, gameState, questionId));
    }
  };

  return (
    <StyledPaper
      isMoneyCell={isMoneyCell && available}
      onClick={onClick}
      data-testid={`game-cell-${dataCellId || label}`}
    >
      {available && (
        <CellText>
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            height: "100%", 
            width: "100%" 
          }}>
            <div style={{
              fontWeight: 'bold',
              fontSize: isMoneyCell ? "4.5rem" : "clamp(1.2rem, 2.2vw, 2.8rem)",
              lineHeight: isMoneyCell ? undefined : 1.15,
              padding: isMoneyCell ? 0 : "0 4px",
              color: isMoneyCell ? ACCENT_YELLOW : "white",
              textShadow: isMoneyCell
                ? "2px 2px 8px rgba(0,0,0,0.5), 0 0 30px rgba(0,0,0,0.2)"
                : "2px 2px 4px rgba(0,0,0,0.3)"
            }}>
              {label.toUpperCase()}
            </div>
          </div>
        </CellText>
      )}
    </StyledPaper>
  );
};

export default GameBoardCell;
